import { ADD_FILE_FOR_TASK_SUCCESS, ADD_FILE_FOR_TASK_FAIL } from "./actionTypes";

const INIT_STATE = {
  res: [],
  error: [],
};

const Team = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_FILE_FOR_TASK_FAIL:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_FILE_FOR_TASK_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    default:
      return state;
  }
};

export default Team;
